import React from 'react';
import { useLocation } from 'react-router-dom';

import LoadingSpinner from '@/components/common/LoadingSpinner';
import { StudentContentBoundary } from '@/components/common/StudentContentBoundary';
import {
  studentRouteLoadingLabel,
  StudentRouteSkeleton,
  studentRouteSkeletonVariant,
} from '@/components/common/StudentLoading';

/** Page-shaped route fallback for student surfaces; all other routes keep the shared spinner. */
const AppRouteLoadingFallback: React.FC = () => {
  const location = useLocation();
  const variant = studentRouteSkeletonVariant(
    location.pathname,
    location.search
  );
  if (!variant) return <LoadingSpinner />;

  const label = studentRouteLoadingLabel(variant);
  return (
    <StudentContentBoundary
      state="pending"
      contentKey={`${location.pathname}${location.search}`}
      label={label}
      skeleton={<StudentRouteSkeleton variant={variant} />}
      animateContent={false}
    >
      {null}
    </StudentContentBoundary>
  );
};

export default AppRouteLoadingFallback;
